import axios from "axios";
import createPersistedState from 'vuex-persistedstate';

const baseUrl = process.env.VUE_APP_API_URL + ""; // URL для получения данных
const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true }

export default {
    namespaced: true,
    state: {
        products: [], // все продукты
        actualProduct: [], // актуальный продукт (когда на странице продукта)
        similarProducts: [], // похожие продукты (когда на странице продукта)
        productsKeys: [], // свойства объекта продукта

        productFilters: [
            {
                name: 'Сортировка',
                type: 'option',
                icon: '<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M13.5285 15.2L10.3285 12H12.7285V4.00005H10.3285L13.5285 0.800049L16.7285 4.00005H14.3285V12H16.7285M0.728516 13.6V12H8.72852V13.6M0.728516 8.80005V7.20005H6.32852V8.80005M0.728516 4.00005V2.40005H3.92852V4.00005H0.728516Z" fill="#1C1C1C"/>\n' +
                    '</svg>',
                defaultValue: 'Сначала новые',
                values: ['Сначала новые', 'Сначала старые', 'Дешевле', 'Дороже']
            },
            {
                name: 'Команда',
                key: 'teams',
                type: 'default',
                icon: '<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M15.4001 1.49357C15.4001 0.835476 1.72852 0.835476 1.72852 1.49357V12.7944C1.72852 15.1862 8.5643 17 8.5643 17C8.5643 17 15.4001 15.1862 15.4001 12.7944V1.49357Z" stroke="black" stroke-width="1.5"/>\n' +
                    '</svg>\n',
                defaultValue: ''
            },
            {
                name: 'Сезон',
                key: 'seasons',
                type: 'default',
                icon: '<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M8.40039 0C3.98919 0 0.400391 3.5888 0.400391 8C0.400391 12.4112 3.98919 16 8.40039 16C12.8116 16 16.4004 12.4112 16.4004 8C16.4004 3.5888 12.8116 0 8.40039 0ZM8.40039 14.4C4.87159 14.4 2.00039 11.5288 2.00039 8C2.00039 4.4712 4.87159 1.6 8.40039 1.6C11.9292 1.6 14.8004 4.4712 14.8004 8C14.8004 11.5288 11.9292 14.4 8.40039 14.4Z" fill="black"/>\n' +
                    '<path d="M9.20059 4H7.60059V8.3312L10.235 10.9656L11.3662 9.8344L9.20059 7.6688V4Z" fill="black"/>\n' +
                    '</svg>',
                defaultValue: ''
            },
            {
                name: 'Цена',
                type: 'price',
                icon: '<svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M14.4004 0C16.5221 0 18.557 0.842855 20.0572 2.34315C21.5575 3.84344 22.4004 5.87827 22.4004 8C22.4004 10.1217 21.5575 12.1566 20.0572 13.6569C18.557 15.1571 16.5221 16 14.4004 16C12.2787 16 10.2438 15.1571 8.74354 13.6569C7.24325 12.1566 6.40039 10.1217 6.40039 8C6.40039 5.87827 7.24325 3.84344 8.74354 2.34315C10.2438 0.842855 12.2787 0 14.4004 0ZM14.4004 14C15.9917 14 17.5178 13.3679 18.643 12.2426C19.7682 11.1174 20.4004 9.5913 20.4004 8C20.4004 6.4087 19.7682 4.88258 18.643 3.75736C17.5178 2.63214 15.9917 2 14.4004 2C12.8091 2 11.283 2.63214 10.1578 3.75736C9.03253 4.88258 8.40039 6.4087 8.40039 8C8.40039 9.5913 9.03253 11.1174 10.1578 12.2426C11.283 13.3679 12.8091 14 14.4004 14ZM2.40039 8C2.40034 9.23994 2.78509 10.4493 3.50155 11.4613C4.21801 12.4733 5.23087 13.2381 6.40039 13.65V15.74C2.95039 14.85 0.400391 11.73 0.400391 8C0.400391 4.27 2.95039 1.15 6.40039 0.26V2.35C4.07039 3.17 2.40039 5.39 2.40039 8Z" fill="#1C1C1C"/>\n' +
                    '</svg>\n',
                defaultValue: ''
            },
            {
                name: 'Размер',
                key: 'size',
                type: 'option',
                icon: '<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M7.57673 2.28919C7.57673 2.67922 7.73178 3.05317 8.00758 3.32897C8.28337 3.60476 8.65731 3.75982 9.04734 3.75982C9.43737 3.75982 9.81132 3.60476 10.0871 3.32897C10.3629 3.05317 10.518 2.67922 10.518 2.28919V1.26879L16.4004 3.22987V8.1717H14.1945V9.76584H12.7239V6.70107H14.9298V4.28904L11.8248 3.25429C11.6804 3.66984 11.4439 4.05177 11.1269 4.36875C10.5753 4.92034 9.8274 5.23044 9.04734 5.23044C8.26728 5.23044 7.17234 4.2258 7.17234 4.2258C7.17234 4.2258 7.17234 4.2258 6.27056 3.25788L6.23538 3.27008L5.76432 1.87701L7.57673 1.26449V2.28919Z" fill="black"/>\n' +
                    '<path d="M1.65192 2.97111L3.08758 2.97111L3.08758 14.0306H1.65192L1.65192 2.97111Z" fill="black"/>\n' +
                    '<path d="M2.36775 0L4.3391 3.40986L0.400391 3.41253L2.36775 0Z" fill="black"/>\n' +
                    '<path d="M13.4279 13.3129V14.7486L1.65757 14.7486L1.65757 13.3129L13.4279 13.3129Z" fill="black"/>\n' +
                    '<path d="M16.4002 14.0286L12.9904 16L12.9878 12.0611L16.4002 14.0286Z" fill="black"/>\n' +
                    '</svg>\n',
                defaultValue: 'Любой',
                values: ['Любой', 'XS', 'S', 'M', 'L', 'XL']
            },
            {
                name: 'Страна',
                key: 'countries',
                type: 'default',
                icon: '<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M0.400391 16V0H8.87098L9.24745 1.88235H14.518V11.2941H7.9298L7.55333 9.41177H2.28274V16H0.400391ZM9.48274 9.41177H12.6357V3.76471H7.69451L7.31804 1.88235H2.28274V7.52941H9.10627L9.48274 9.41177Z" fill="black"/>\n' +
                    '</svg>\n',
                defaultValue: ''
            },
            {
                name: 'Состояние',
                key: 'conditions',
                type: 'option',
                icon: '<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M8.40039 15.2L0.400391 5.60005L2.80039 0.800049H14.0004L16.4004 5.60005L8.40039 15.2ZM6.50039 4.80005H10.3004L9.10039 2.40005H7.70039L6.50039 4.80005ZM7.60039 11.74V6.40005H3.16039L7.60039 11.74ZM9.20039 11.74L13.6404 6.40005H9.20039V11.74ZM12.0804 4.80005H14.2004L13.0004 2.40005H10.8804L12.0804 4.80005ZM2.60039 4.80005H4.72039L5.92039 2.40005H3.80039L2.60039 4.80005Z" fill="black"/>\n' +
                    '</svg>\n',
                defaultValue: 'Любое',
                values: ['Любое', 'Новая вещь', 'Отличное', 'Хорошее', 'Удовлетворительное', 'Плохое']
            },
            {
                name: 'Бренд',
                key: 'brands',
                type: 'default',
                icon: '<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M6.80039 11.2H10.0004C10.2271 11.2 10.4172 11.1232 10.5708 10.9696C10.7244 10.816 10.8009 10.6261 10.8004 10.4V8.8H9.20039V9.6H7.60039V6.4H9.20039V7.2H10.8004V5.6C10.8004 5.37333 10.7236 5.18347 10.57 5.0304C10.4164 4.87733 10.2265 4.80053 10.0004 4.8H6.80039C6.57372 4.8 6.38386 4.8768 6.23079 5.0304C6.07772 5.184 6.00092 5.37387 6.00039 5.6V10.4C6.00039 10.6267 6.07719 10.8168 6.23079 10.9704C6.38439 11.124 6.57426 11.2005 6.80039 11.2ZM8.40039 16C7.29372 16 6.25372 15.7899 5.28039 15.3696C4.30706 14.9493 3.46039 14.3795 2.74039 13.66C2.02039 12.9405 1.45052 12.0939 1.03079 11.12C0.611058 10.1461 0.400925 9.10613 0.400392 8C0.399858 6.89386 0.609992 5.85387 1.03079 4.88C1.45159 3.90613 2.02146 3.05947 2.74039 2.34C3.45932 1.62053 4.30599 1.05067 5.28039 0.6304C6.25479 0.210133 7.29479 0 8.40039 0C9.50599 0 10.546 0.210133 11.5204 0.6304C12.4948 1.05067 13.3415 1.62053 14.0604 2.34C14.7793 3.05947 15.3495 3.90613 15.7708 4.88C16.1921 5.85387 16.402 6.89386 16.4004 8C16.3988 9.10613 16.1887 10.1461 15.77 11.12C15.3513 12.0939 14.7815 12.9405 14.0604 13.66C13.3393 14.3795 12.4927 14.9496 11.5204 15.3704C10.5481 15.7912 9.50812 16.0011 8.40039 16ZM8.40039 14.4C10.1871 14.4 11.7004 13.78 12.9404 12.54C14.1804 11.3 14.8004 9.78666 14.8004 8C14.8004 6.21333 14.1804 4.7 12.9404 3.46C11.7004 2.22 10.1871 1.6 8.40039 1.6C6.61372 1.6 5.10039 2.22 3.86039 3.46C2.62039 4.7 2.00039 6.21333 2.00039 8C2.00039 9.78666 2.62039 11.3 3.86039 12.54C5.10039 13.78 6.61372 14.4 8.40039 14.4Z" fill="black"/>\n' +
                    '</svg>\n',
                defaultValue: '',
            }
        ] // существующие фильтры продуктов
    },

    mutations: {
        SET_PRODUCTS(state, payload) {
            state.products = payload;
        },

        SET_ACTUAL_PRODUCT(state, payload) {
            state.actualProduct = payload;
        },

        SET_SIMILAR_PRODUCTS(state, payload) {
            state.similarProducts = payload;
        },

        SET_PRODUCTS_KEYS(state, payload) {
            state.productsKeys = payload;
        },
    },

    actions: {
        async fetchProducts({ commit }, params) {
            try {
                let transformedData;

                const response = await axios.get(
                    `${baseUrl}/products/getProducts`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'Код': obj.code,
                            'Название продукта': obj.product_name,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Тип продукта': obj.product_type,
                            'Размер': obj.size_name,
                            'Состояние': obj.product_condition,
                            'Дата последнего изменения': obj.date_last_change,
                            'Бренд': obj.brand,
                            'Команда': obj.team_and_country,
                            'Сезон': obj.season,
                            'Автор': obj.create_by
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_PRODUCTS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },
        async fetchProductsAdmin({ commit }, params) {
            try {
                let transformedData;

                const response = await axios.get(
                    `${baseUrl}/products/getProductsAdmin`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'Код': obj.code,
                            'Название продукта': obj.product_name,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Тип продукта': obj.product_type,
                            'Размер': obj.size_name,
                            'Состояние': obj.product_condition,
                            'Дата последнего изменения': obj.date_last_change,
                            'Бренд': obj.brand,
                            'Команда': obj.team_and_country,
                            'Сезон': obj.season,
                            'Автор': obj.create_by,
                            'Цена закупки': obj.buying_price
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_PRODUCTS', transformedData); // сохраняем данные в состояние

                commit('SET_PRODUCTS_KEYS', {
                    'Название продукта': "productName",
                    'Обычная цена': "commonPrice",
                    'Цена по скидке': "salePrice",
                    "Описание": "descriptionText",
                    "Недостатки": "issuesText",
                    'Тип продукта': "typeName",
                    'Размер': "sizeName",
                    'Состояние': "conditionName",
                    'Сезон': "season",
                    'Бренд': "brandName",
                    'Команда': "teamName",
                    'Автор': "creatorEmail",
                    'Цвет': "colors",
                    'Статус': "statusName",
                    'Закупочная цена': "buyingPrice",
                });
            } catch (error) {
                console.error(error);
            }
        },
        async fetchActualProduct({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/products/getProductByCode`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'Код': obj.code,
                            'Название продукта': obj.product_name,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Описание': obj.description,
                            'Недостатки': obj.issues_text,
                            'Дата последнего изменения': obj.date_last_change,
                            'Тип продукта': obj.product_type,
                            'Размер': obj.size_name,
                            'Состояние': obj.product_condition,
                            'Сезон': obj.season,
                            'Команда': obj.team_and_country,
                            'Бренд': obj.brand,
                            'Автор': obj.create_by,
                            'Статус': obj.status,
                            'Закупочная цена': obj.buying_price
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_ACTUAL_PRODUCT', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },
        async fetchSimilarProducts({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/products/getSimilarProducts`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'Код': obj.code,
                            'Название продукта': obj.product_name,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Описание': obj.description,
                            'Недостатки': obj.issues_text,
                            'Дата последнего изменения': obj.date_last_change,
                            'Тип продукта': obj.product_type,
                            'Размер': obj.size_name,
                            'Состояние': obj.product_condition,
                            'Сезон': obj.season,
                            'Команда': obj.team_and_country,
                            'Бренд': obj.brand,
                            'Автор': obj.create_by
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_SIMILAR_PRODUCTS', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },
    },
    plugins: [
        createPersistedState({
            key: 'product',
            storage: window.localStorage, // или sessionStorage
            paths: [
                'cart'
            ],
        })
    ],
}